/* global DecompressionStream, CompressionStream */
import { QuantumDriveT, 
         QuantumDriveC, 
         GetSystemLabel,
         GetBusinessLabel }       from "Utilities/utils";
import {useLoader       }       from "components/Covers/loadingCover";
import { useModal       }       from "components/Covers/genericModal";
import Style                    from "components/UI/main.module.scss";
import React                    from "react";

const ModalContent         = React.memo(({...Content}) => {    
    const {Message, ClickAction} = Content;
    return (
        <div>
            <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                    <div className={[Style.p_5].join(" ")}>
                        <span className={[Style.text_body, Style.fs_8].join(" ")}>
                            {Message}
                        </span>
                    </div>
                </div>
            </div>        
        </div>
    );
});

export async function decompressContent(base64String) {
    try {
        if (!base64String.startsWith("H4sI")) {
            return JSON.parse(base64String);
        }

        const binaryString = atob(base64String);
        const bytes = Uint8Array.from(binaryString, c => c.charCodeAt(0));

        const stream = new Blob([bytes])
            .stream()
            .pipeThrough(new DecompressionStream('gzip'));

        const decompressedText = await new Response(stream).text();

        return JSON.parse(decompressedText);
    } catch (err) {
        console.error("Decompression failed:", err);
        return null;
    }
}
export async function compressContent(obj) {
    const json = JSON.stringify(obj);

    const stream = new Blob([json]).stream()
        .pipeThrough(new CompressionStream('gzip'));

    const compressedBuffer = await new Response(stream).arrayBuffer();

    return btoa(
        String.fromCharCode(...new Uint8Array(compressedBuffer))
    );
}
export async function Generic_Call(sys_body) 
{
    const   { hideLoader }      = useLoader();  
    const   { showModal }       = useModal();
    let     server_response     = {};
    let     controller          = new AbortController();
    const   timeoutMs           = 29000 << 5;
    let     timeoutId           = setTimeout(() => controller.abort(), timeoutMs);
    const   baseURL             = `${process.env.REACT_APP_API_BASE_URL}/${sys_body.Endpoint}`;
    
    try {        
        server_response = await fetch(baseURL, {method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                body: JSON.stringify(sys_body),
                                                signal: controller.signal
                                                });
        clearTimeout(timeoutId);

        if (!server_response.ok) {
            hideLoader();
            throw new Error(`HTTP error! Status: ${server_response.status}`);
        }
        
        const data = await server_response.json();

        return data;
    } 
    catch (error) {
        clearTimeout(timeoutId);
        hideLoader();

        if (error.name === "AbortError") {
            console.error("Request timed out");
            showModal(<ModalContent Message={GetSystemLabel("ErrorTimeout")}/>);
            return { error: "timeout" };
        }

        if (error instanceof TypeError) {
            console.error("Request timed out");
            showModal(<ModalContent Message={GetSystemLabel("ErrorNetwork")}/>);
            return { error: "network" };
        }

        console.error("Fetch error:", error);
        showModal(<ModalContent Message={GetSystemLabel("ErrorUnexpected")}/>);

        return null;
    }
}
export async function GetSeferData(endpoint, content) 
{
    let compressed = true;
    let payload = {};
    try {    
        const currT = localStorage.getItem("Tolkien");
        const currC = localStorage.getItem("Charlore");

        const default_payload = {
            Endpoint: endpoint,
            Charlore: JSON.parse(currC),
            Tolkien: currT,
            Compressed: compressed,
            Content: compressed === true ? await compressContent(content ?? {}) : JSON.stringify(content)
        };

        payload = await Generic_Call(default_payload);
        
        if (!payload) return payload;

        if (payload?.Status?.Code === 1939) {
            localStorage.removeItem("Charlore");
            localStorage.removeItem("Tolkien");
            localStorage.removeItem("last_feature");
            window.location.href = '/';
            return;
        }
        
        const respContent = payload?.Response?.Content;
        if (respContent && typeof respContent === "string") {
            if (payload?.Response?.Compressed === true) {
                const decompressed = await decompressContent(respContent);
                if (decompressed) {
                    payload.Response.Content = decompressed; // No JSON.parse here, decompressContent does it
                }
            }
            else {
                payload.Response.Content = JSON.parse(payload.Response.Content);
            }
        }
        if (JSON.stringify(payload.Response.Tolkien) !== currT) {
            QuantumDriveT(payload.Response.Tolkien);
        }
        if (JSON.stringify(payload.Response.Charlore) !== currC) {
            QuantumDriveC(payload.Response.Charlore);
        }        
        
        return payload;
    } 
    catch (error) {
        console.error("GetSeferData error:", error);
        return payload;
    }
}